'use client';
import { Suspense } from 'react';
import { IntlProvider } from 'react-intl';
import { SchemeProvider } from '@osmosis/react-ui/context/SchemeContext';
import StyledComponentsRegistry from '../app/registry';
import NotFoundComponent from './NotFoundComponent';

type Props = {
  variant?: 'notFound' | 'gone';
};

/**
 * Standalone providers for the 404/410 pages, which render outside the app layout providers.
 */
const NotFoundPageShell = ({ variant }: Readonly<Props>) => (
  <StyledComponentsRegistry>
    <SchemeProvider scheme="light">
      <IntlProvider locale="en">
        <Suspense>
          <NotFoundComponent variant={variant} />
        </Suspense>
      </IntlProvider>
    </SchemeProvider>
  </StyledComponentsRegistry>
);

export default NotFoundPageShell;
